import { SupportedChainId } from './chains'

export const REFERRALS_SUBGRAPH_URL: Record<number, string> = {
  [SupportedChainId.POLYGON]: 'https://api.thegraph.com/subgraphs/name/shibaworldcup/casino-referrals',
  [SupportedChainId.POLYGON_MUMBAI]: 'https://api.thegraph.com/subgraphs/name/shibaworldcup/casino-referrals-mumbai',
}
export const DICE_SUBGRAPH_URL: Record<number, string> = {
  [SupportedChainId.POLYGON]: 'https://api.thegraph.com/subgraphs/name/shibaworldcup/casino-dice',
  [SupportedChainId.POLYGON_MUMBAI]: 'https://api.thegraph.com/subgraphs/name/shibaworldcup/casino-dice-mumbai',
}
export const ROULETTE_SUBGRAPH_URL: Record<number, string> = {
  [SupportedChainId.POLYGON]: 'https://api.thegraph.com/subgraphs/name/shibaworldcup/casino-roulette',
  [SupportedChainId.POLYGON_MUMBAI]: 'https://api.thegraph.com/subgraphs/name/shibaworldcup/casino-roulette-mumbai',
}
export const SPORT_SUBGRAPH_URL: Record<number, string> = {
  [SupportedChainId.POLYGON]: 'https://api.thegraph.com/subgraphs/name/shibaworldcup/casino-bets',
  [SupportedChainId.POLYGON_MUMBAI]: 'https://api.thegraph.com/subgraphs/name/jamonswap/acorn-bets',
}
